import React from "react";
import { sanitizeInput } from "../../../../utils/securityUtils";
import { isIOS } from "../../../../utils/iosdevice";

const BillingForm = ({
  formData,
  updateBillingField,
  formDataError,
  countries,
  title,
  states
}) => {
  // Handle input with sanitization
  const handleInputChange = (field, value, type = "text") => {
    const sanitized = sanitizeInput(value, type);
    updateBillingField(field, sanitized);
  };

  return (
    <div className="mt-10">
      <h2 className="font-redhatBold mb-[1.2vw] text-primary text-[4vw] md:text-[2.5vw] xl:text-[1.5vw]">
        Billing Details
      </h2>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Title*
          </label>
          <select
            value={formData.billing.title}
            onChange={(e) => updateBillingField("title", e.target.value)}
            className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${isIOS ? 'min-h-[44px]' : null}  focus:outline-none focus:ring-0`}
          >
            <option value="">Select</option>
            {title &&
              title?.map((el, ind) => (
                <option key={el.id} value={`${el.id}-${el.name}`}>
                  {el.name}
                </option>
              ))}
          </select>
          {formDataError.billing.title && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.title}
            </p>
          )}
        </div>
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            First Name*
          </label>
          <input
            value={formData.billing.firstName}
            onChange={(e) =>
              handleInputChange("firstName", e.target.value, "name")
            }
            type="text"
            placeholder="Enter First Name"
            maxLength={50}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.firstName && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.firstName}
            </p>
          )}
        </div>
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Last Name*
          </label>
          <input
            value={formData.billing.lastName}
            onChange={(e) =>
              handleInputChange("lastName", e.target.value, "name")
            }
            type="text"
            placeholder="Enter Last Name"
            maxLength={50}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.lastName && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.lastName}
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Country Code*
          </label>
          <select
            value={formData.billing.countryCode}
            onChange={(e) => updateBillingField("countryCode", e.target.value)}
            className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${isIOS ? 'min-h-[44px]' : null}  focus:outline-none focus:ring-0`}
          >
            <option value="">Select</option>
            {countries &&
              countries?.map((el, ind) => {
                return (
                  <option key={el.id} value={el.phone_code}>
                    {`+ ${el.phone_code}`}
                  </option>
                );
              })}
          </select>
          {formDataError.billing.countryCode && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.countryCode}
            </p>
          )}
        </div>
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Mobile*
          </label>
          <input
            value={formData.billing.mobile}
            onChange={(e) =>
              handleInputChange("mobile", e.target.value, "numeric")
            }
            type="text"
            placeholder="Enter Mobile"
            maxLength={15}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.mobile && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.mobile}
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Address*
          </label>
          <input
            value={formData.billing.address}
            onChange={(e) =>
              updateBillingField("address", e.target.value, "text")
            }
            type="text"
            placeholder="Enter Address"
            maxLength={200}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.address && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.address}
            </p>
          )}
        </div>
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            City*
          </label>
          <input
            value={formData.billing.city}
            onChange={(e) => handleInputChange("city", e.target.value, "name")}
            type="text"
            placeholder="Enter City"
            maxLength={50}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.city && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.city}
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Country*
          </label>
          <select
            value={formData.billing.country}
            onChange={(e) => updateBillingField("country", e.target.value)}
            className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${isIOS ? 'min-h-[44px]' : null}  focus:outline-none focus:ring-0`}
          >
            <option value="">Select</option>
            {countries &&
              countries?.map((el, ind) => {
                return (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                );
              })}
          </select>
          {formDataError.billing.country && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.country}
            </p>
          )}
        </div>
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            State*
          </label>
          {states && states?.length > 0 ? (
            <select
              value={formData?.billing?.state}
              onChange={(e) => updateBillingField("state", e.target.value)}
              className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${isIOS ? 'min-h-[44px]' : null}  focus:outline-none focus:ring-0`}
            >
              <option value="">Select State</option>
              {states &&
                states.map((el, ind) => {
                  return (
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  );
                })}
            </select>
          ) : (
            <input
              type="text"
              placeholder="Enter State"
              value={formData?.billing?.state}
              onChange={(e) => updateBillingField("state", e.target.value)}
              maxLength={50}
              className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw]"
            />
          )}
          {formDataError.billing.state && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.state}
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Pincode*
          </label>
          <input
            value={formData.billing.pincode}
            onChange={(e) =>
              updateBillingField("pincode", e.target.value)
            }
            type="text"
            placeholder="Enter Pincode"
            maxLength={10}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.pincode && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.pincode}
            </p>
          )}
        </div>
        <div>
          <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
            Email ID*
          </label>
          <input
            value={formData.billing.email}
            onChange={(e) => handleInputChange("email", e.target.value, "text")}
            type="email"
            placeholder="Enter Email"
            maxLength={100}
            className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
          />
          {formDataError.billing.email && (
            <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
              {formDataError.billing.email}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillingForm;
